import { DashboardProvider } from './dashboard.provider';
import { SalesReport } from './overview/sales/sales-report';
import { Stats } from './overview/stats';
import { RecentTransections } from './overview/transections/recent-transection';
import { HeaderAction } from './shortcut.action/header-action';

export const Dashboard = () => {
    return (
        <DashboardProvider>
            <div className="space-y-4">
                <HeaderAction />
                <Stats />
                <div className="3xl:grid grid-cols-8 gap-4 space-y-4">
                    <div className="col-span-4">
                        <RecentTransections />
                    </div>
                    <div className="col-span-4 w-full">
                        <SalesReport />
                    </div>
                </div>
            </div>
        </DashboardProvider>
    );
};
